// File: src/pages/TransformXHome.jsx
import React, { useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const tabs = [
  { id: "about", label: "About", iconClass: "fas fa-info-circle" },
  { id: "students", label: "Students & Youth", iconClass: "fas fa-user-graduate" },
  { id: "professionals", label: "Working Professionals", iconClass: "fas fa-briefcase" },
  { id: "entrepreneurs", label: "Entrepreneurs & Creators", iconClass: "fas fa-lightbulb" },
  { id: "institutions", label: "Institutions & Enterprises", iconClass: "fas fa-building" },
  { id: "government", label: "Government & Public Sector", iconClass: "fas fa-landmark" },
];

const subTargets = {
  students: ["School Students 🎓", "College Students 📚", "Exam Aspirants 📝", "Skill Seekers 💡", "Early Job Seekers 👩‍💼", "Student Clubs 🤝"],
  professionals: ["Early Career 👨‍💼", "Mid-Career 🔄", "Managers & Leads 👔", "Corporate Employees 🏢", "Career Switchers 🔀", "Productivity Seekers ⏱️"],
  entrepreneurs: ["Startup Founders 🚀", "Solopreneurs 💻", "Small Business Owners 🏪", "Creators 🎨", "Coaches & Trainers 📈", "Side-Hustlers 💡"],
  institutions: ["BFSI 🏦", "Schools & Colleges 🎓", "Corporates 🏢", "Healthcare 🏥", "NGOs 🤝", "Associations 🌐"],
  government: ["Skill Missions 🛠️", "MSME Departments 📊", "Rural Development 🌾", "Education & Youth 🎓", "Digital Inclusion 🌐", "Women Empowerment 👩‍🎓"],
};

const doughnutData = {
  labels: ['Students', 'Professionals', 'Entrepreneurs', 'Institutions', 'Government'],
  datasets: [
    {
      label: 'Target Focus Distribution',
      data: [25, 20, 15, 25, 15],
      backgroundColor: ['#1E3A8A', '#2563EB', '#3B82F6', '#60A5FA', '#93C5FD'],
      borderColor: ['#000', '#000', '#000', '#000', '#000'],
      borderWidth: 1,
    },
  ],
};

const TransformXHome = () => {
  const [activeTab, setActiveTab] = useState("students");
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div className="bg-black text-white min-h-screen flex flex-col">
      <header className="sticky top-0 bg-black/90 backdrop-blur-sm z-50 p-4 flex justify-between items-center border-b border-blue-700">
        <h1 className="text-xl font-bold text-blue-400">Think5Whys TransformX™</h1>
        <span className="text-sm text-white">A Transformation-as-a-Platfrom for Clarity, Capability & Growth</span>
      </header>

      <nav className="bg-gray-900 p-1 grid grid-cols-3 lg:grid-cols-5 gap-1 place-items-center">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => { setActiveTab(tab.id); setShowPreview(false); }}
            className={`flex justify-center items-center gap-2 px-1 py-1 rounded-md font-medium text-xs lg:text-sm ${
              activeTab === tab.id ? "bg-blue-700 text-white" : "text-blue-300 hover:bg-blue-900"
            }`}
          >
            <i className={`${tab.iconClass}`}></i> {tab.label}
          </button>
        ))}
      </nav>

      {/* Main Content */}
      <main className="flex-1 p-1 grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
        {activeTab !== "about" &&
          subTargets[activeTab].map((item, idx) => (
            <button
              key={idx}
              className="flex justify-center items-center gap-2 bg-gray-800 hover:bg-blue-800 transition-colors p-1 rounded-lg text-xs lg:text-sm text-left text-white shadow-sm"
            >
              {item}
            </button>
          ))}

        {activeTab === "about" && (
          <div className="col-span-full bg-gray-900 p-4 rounded-lg shadow-lg">
            <h2 className="text-m lg:text-lg font-bold text-yellow-200 mb-4">About Think5Whys TransformX™</h2>
            <p className="text-sm lg:text-m mb-2">
              Think5Whys TransformX™ is a Transformation-as-a-Platform enabling Individuals, Businesses,
              and Governments to build <strong>clarity, capability, discipline and growth</strong>.
            </p>
            <p className="text-sm lg:text-m mb-2">
              Global focus on 5-year high-impact segments: Students, Working Professionals, Entrepreneurs,
              Institutions (BFSI, Schools, Corporates), Governments (MSME, Skill, Rural, Youth).
            </p>
            <p className="text-sm lg:text-m mb-2">
              Built around frameworks for diagnostics, behavioural transformation, capability development,
              AI-powered insight engines, and measurable outcomes.
            </p>

            <button
              onClick={() => setShowPreview(!showPreview)}
              className="bg-blue-700 hover:bg-blue-800 text-white w-32 lg:w-40 px-4 py-2 rounded-md text-sm lg:text-m mt-2 mb-2"
            >
              {showPreview ? "Hide Preview" : "Show Preview"}
            </button>

            {showPreview && (
              <div className="mt-2 max-w-sm lg:max-w-m mx-auto">
                <Doughnut data={doughnutData} />
              </div>
            )}
          </div>
        )}
      </main>

      <footer className="sticky bottom-0 bg-black/90 backdrop-blur-sm p-4 text-center border-t border-blue-700 text-blue-300 text-sm">
        © 2025 Think5Whys | All Rights Reserved
      </footer>
    </div>
  );
};

export default TransformXHome;
